import React from "react";
import {Table} from "antd";
import {ColumnsType} from "antd/lib/table";
import {_t} from "../../../Common/components/InjectIntlContext";
import {useAuthLog} from "../../apiHooks";
import {NoData} from "../../../Common/components/NoData";

const columns = (_t: any): ColumnsType<any> => [
  {
    title: _t("IP"),
    dataIndex: "ip",
    key: "ip",
  },
  {
    title: _t("Date"),
    dataIndex: "timestamp",
    key: "timestamp",
  },
  {
    title: _t("login_attempt"),
    dataIndex: "success",
    key: "success",
    render: (val) => val ? _t('login') : _t('attempt'),
  },
];

const useTableData = (id) => {
  const {isLoading, data} = useAuthLog({
    user_id: id,
  });
  return {isLoading, data};
};

export function AuthLogWidget({user}) {
  const {data, isLoading} = useTableData(user?.id);
  const translatedColumns = columns(_t);
  return (
    <>
      <Table
        loading={isLoading}
        columns={translatedColumns}
        rowKey="date"
        dataSource={data?.data}
        pagination={false}
        locale={{ emptyText: <NoData /> }}
      />
      <br/>
    </>
  );
}
